import app from '@/main'

export const state = {
  locale: '',
}

export const getters = {
  getLang: (state) => state.locale,
}

export const mutations = {
  CHANGE_LANG(state, payload) {
    state.locale = payload
    app.$i18n.locale = payload
  },
}

export const actions = {
  changeLang({ commit }, payload) {
    commit('CHANGE_LANG', payload)
  },
}
